import Link from "next/link";

import type { SiteLocale } from "@/lib/graphql";

import { type FragmentOf, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function ResponsiveBanner(props: {
  record: FragmentOf<typeof fragment.ResponsiveBannerFragment>;
  locale: SiteLocale;
}) {
  const record = readFragment(fragment.ResponsiveBannerFragment, props.record);

  if (!record.banner) {
    return null;
  }

  return (
    <div className="container mx-auto my-10 max-w-[780px] px-4 lg:px-0">
      {record.banner.map((ban) => (
        <Link key={ban.id} href={`${ban?.url || "/"}`}>
          <picture>
            {ban?.desktopBanner?.url && (
              <source media="(min-width: 1024px)" srcSet={`${ban?.desktopBanner?.url}`} />
            )}
            {ban?.mobileBanner?.url && (
              <source media="(max-width: 1023px)" srcSet={`${ban?.mobileBanner?.url}`} />
            )}
            <img src={`${ban?.desktopBanner?.url}`} alt="banner" />
          </picture>
        </Link>
      ))}
    </div>
  );
}
